import React, { useState } from 'react'
import { Box, Grid } from '@material-ui/core'

import { Container, Page, RoundedBorder } from 'components'
import {
  Header,
  PrivacyByDesignReportForm,
  ReportVersionTable,
} from './components'

import constants from 'constants/index'
import useStyles from './styles'

const PrivacyByDesignReport = () => {
  const [refresher, setRefresher] = useState(false)
  const [currentReportVersion, setCurrentReportVersion] = useState()

  const classes = useStyles()

  const { privacyByDesign } = constants.reports.DESCRIPTION

  return (
    <Page className={classes.root} title={privacyByDesign.title}>
      <Box position="relative">
        <RoundedBorder />
      </Box>
      <Container maxWidth={false} spacingXl={15} spacingLg={10} spacingMd={5}>
        <Box py={5}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Header
                title={privacyByDesign.title}
                description={privacyByDesign.content}
              />
            </Grid>
            <Grid item xs={12}>
              <PrivacyByDesignReportForm
                refresh={() => setRefresher(!refresher)}
              />
            </Grid>
            <Grid item xs={12}>
              <ReportVersionTable
                currentReportVersion={currentReportVersion}
                kind={constants.reportVersions.KIND.PRIVACY_BY_DESIGN}
                refresher={refresher}
                setCurrentReportVersion={setCurrentReportVersion}
              />
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Page>
  )
}

export default PrivacyByDesignReport
